module.exports = __webpack_public_path__ + "img/arrival-confirmed.bb86abc4.svg";